import React, { useState, useContext } from 'react';
import {
  Button,
  Card,
  CardMedia,
  CardTitle,
  Typography,
} from '@one-thd/sui-atomic-components';
import { ArrowDown, ArrowUp } from '@one-thd/sui-icons';
import { AppContext } from '@thd-nucleus/app-render';
import { RentalsServicesSkeleton } from '../subcomponents/Skeletons';
import { ShopAllCard } from './ShopAllCard';

const COLLAPSED_COUNT = 10;

const CompactCard = ({ item }) => (
  <Card
    href={`${item.link}?emt=ppsrc_2603`}
    className="sui-h-full sui-w-full sui-border sui-border-primary"
  >
    <CardMedia
      src={item.imageUrl}
      alt={item.description}
      aspect="square"
      style={{ objectFit: 'contain' }}
      padding
      loading="lazy"
    />
    <CardTitle
      header={(
        <Typography variant="h3" weight="bold" style={{ fontSize: '1.8rem' }}>
          {item.description}
        </Typography>
      )}
    />
  </Card>
);

const RentalCompactGrid = ({ title, rentalItems, loading, error }) => {
  const { instance } = useContext(AppContext);
  const thdSeoBotDetected = instance?.thdSEOBotDetection;
  const [showAll, setShowAll] = useState(!!thdSeoBotDetected);

  if (loading) return <RentalsServicesSkeleton />;
  if (!rentalItems?.length || error) return null;

  const shouldCollapse = rentalItems.length > COLLAPSED_COUNT;
  const visibleItems = showAll ? rentalItems : rentalItems.slice(0, COLLAPSED_COUNT);

  return (
    <div className="sui-flex sui-flex-col sui-gap-4">
      <Typography variant="h2" weight="display">{title}</Typography>

      <div className="sui-grid sui-grid-cols-2 lg:sui-grid-cols-5 sui-gap-6">
        {visibleItems.map((item, index) => (
          <React.Fragment key={item.link || `rental-${index}`}>
            {index === 0
              ? <ShopAllCard item={item} titleSize="1.8rem" />
              : <CompactCard item={item} />}
          </React.Fragment>
        ))}
      </div>

      {shouldCollapse && (
        <div className="sui-flex sui-items-center sui-justify-center">
          <Button
            variant="text"
            endIcon={showAll ? ArrowUp : ArrowDown}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? 'View Less' : 'View More'}
          </Button>
        </div>
      )}
    </div>
  );
};

export default RentalCompactGrid;